import { ToggleButton } from 'common/Prose/Toolbar/ToolbarBravo/WriterFormatToolbar/Button'
import { Italic } from 'blaze-ui/icons'
import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { observer } from 'mobx-react-lite'
import { useItalicToggle } from 'common/Prose/Toolbar/hooks/useItalicToggle'
import { PressEvent } from '@react-types/shared'

const Italic24 = () => <Italic size={24} />

export const ItalicButton = observer(() => {
  const view = useEditorView()
  const { active, disabled, handleClick } = useItalicToggle(view)

  const onPress = (e: PressEvent) => {
    handleClick(e)
    view.dispatch(view.state.tr.scrollIntoView())
  }

  return (
    <ToggleButton
      preventFocusOnPress
      on={active}
      onPress={onPress}
      isDisabled={disabled}
      icon={Italic24}
      aria-label="Italic"
    />
  )
})
